import { Badge } from '@bbpos/ui';

export interface PlatformUserStatusBadgeProps {
  isActive: boolean;
  size?: 'sm' | 'md';
}

export function PlatformUserStatusBadge({ isActive, size = 'sm' }: PlatformUserStatusBadgeProps) {
  return (
    <Badge variant={isActive ? 'success' : 'draft'} size={size}>
      <span className="flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-current" />
        {isActive ? 'Active' : 'Deactivated'}
      </span>
    </Badge>
  );
}
